import type { NotificationInstance } from 'antd/es/notification/interface';

let currentToastMessage: string | null = null;
let notificationInstance: NotificationInstance | null = null;

// App 컴포넌트에서 notification 인스턴스를 설정
export const setNotificationInstance = (instance: NotificationInstance): void => {
  notificationInstance = instance;
};

const success = (message: string): void => {
  if (!notificationInstance) {
    console.warn('Notification instance not initialized');
    return;
  }
  if (message !== currentToastMessage) {
    currentToastMessage = message;
    notificationInstance.success({
      message,
      onClose: () => {
        currentToastMessage = null;
      },
    });
  }
};

const info = (message: string): void => {
  if (!notificationInstance) {
    console.warn('Notification instance not initialized');
    return;
  }
  if (message !== currentToastMessage) {
    currentToastMessage = message;
    notificationInstance.info({
      message,
      onClose: () => {
        currentToastMessage = null;
      },
    });
  }
};

const error = (message: string, error?: unknown): void => {
  console.error(error ?? message);

  if (!notificationInstance) {
    console.warn('Notification instance not initialized');
    return;
  }
  if (message !== currentToastMessage) {
    currentToastMessage = message;
    notificationInstance.error({
      message,
      onClose: () => {
        currentToastMessage = null;
      },
    });
  }
};

export default {
  success,
  info,
  error,
};
